'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguage = getLanguage;
exports.getTranslations = getTranslations;
exports.replaceTranslations = replaceTranslations;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _getLang = require('I18n/utils/getLang');

var _getLang2 = _interopRequireDefault(_getLang);

var _getLangLocale = require('I18n/utils/getLangLocale');

var _getLangLocale2 = _interopRequireDefault(_getLangLocale);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getLanguage() {
  return new _q2.default.Promise(function (resolve) {
    _I18n2.default.Info.then(function () {
      var getLangValue = (0, _getLang2.default)();
      if (_I18n2.default.translations[getLangValue]) {
        resolve(getLangValue);
      }
      resolve((0, _getLangLocale2.default)());
    });
  });
}

function getTranslations(lang) {
  return _I18n2.default.translations[lang];
}

function replaceTranslations() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  var translations = arguments[1];

  _I18n2.default.translations[lang] = translations;
  return true;
}


//////////////////
// WEBPACK FOOTER
// ./js/api/I18nApi.js
// module id = 357
// module chunks = 3 4 5